import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	checkboxLabel: {
		id: 'issue-field-sprint.edit.menu.checkbox-label',
		defaultMessage: 'Only show sprints in this project ({projectKey})',
		description: 'Checkbox label. Allows to restrict Sprints in search results.',
	},
});
